import { render, staticRenderFns } from "./SvgModal.vue?vue&type=template&id=d737d610&"
import script from "./SvgModal.vue?vue&type=script&lang=js&"
export * from "./SvgModal.vue?vue&type=script&lang=js&"
import style0 from "./SvgModal.vue?vue&type=style&index=0&id=d737d610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports